'use strict';

var React = require('react');

var SvgShippingLabelIcon = function SvgShippingLabelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 5.75a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.5a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5h-5.5a.75.75 0 0 1-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14v-1a.75.75 0 0 0-1.5 0v1a.75.75 0 0 0 1.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 13v1a.75.75 0 0 1-1.5 0v-1a.75.75 0 0 1 1.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 14v-1a.75.75 0 0 0-1.5 0v1a.75.75 0 0 0 1.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 4.25a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-10a1 1 0 0 1-1-1v-12Zm1.5 11.5v-11h9v11h-9Z"
  }));
};
SvgShippingLabelIcon.displayName = "ShippingLabelIcon";

exports.SvgShippingLabelIcon = SvgShippingLabelIcon;
